<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar :key="'topbar:' + $appState.locale" @menu-toggle="onMenuToggle" />
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :key="'menu:' + $appState.locale" :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <!-- <router-view @updateEventMenu="updateEventMenuHandler" /> -->
			<router-view :key="$appState.locale" />
            </div>
            <AppFooter />
        </div>

        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>

        <Toast />
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
			menuActive: false,
            eventRecordBadge: '0'
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    mounted() {
        this.getTodayTotalEvent();
        //this.timer = setInterval(this.getTodayTotalEvent, 10000);
    },
    methods: {
		buildMenu() {
			return [
				{
					label: this.$t('nav.analytics.group'),
					items: [
						{ label: this.$t('nav.analytics.total'), icon: 'pi pi-fw pi-home', to: '/' },
						{ label: this.$t('nav.analytics.chartStats'), icon: 'pi pi-fw pi-chart-pie', to: '/charttable' },
						{ label: this.$t('nav.analytics.test'), icon: 'pi pi-fw pi-chart-pie', to: '/bigscreen' }
					]
				},
				{
					label: this.$t('nav.enterprise.group'),
					icon: 'pi pi-fw pi-sitemap',
					items: [
						{ label: this.$t('nav.enterprise.config'), icon: 'pi pi-fw pi-server', to: '/groupconfig' },
						{ label: this.$t('nav.enterprise.notice'), icon: 'pi pi-fw pi-bell', to: '/notifymanage' }
					]
				},
				{
					label: this.$t('nav.events.group'),
					items: [
						{ label: this.$t('nav.events.records'), icon: 'pi pi-fw pi-eye', to: '/eventrecords', badge: this.eventRecordBadge },
						{ label: this.$t('nav.events.sensors'), icon: 'pi pi-fw pi-cog', to: '/sensormanage' }
					]
				},
				{
					label: this.$t('nav.shower.group'),
					items: [
						{ label: this.$t('nav.shower.recordsStaff'), icon: 'pi pi-fw pi-eye', to: '/showerrecords' },
						{ label: this.$t('nav.shower.recordsDevice'), icon: 'pi pi-fw pi-eye', to: '/showerrecordswithdevice' },
						{ label: this.$t('nav.shower.devices'), icon: 'pi pi-fw pi-cog', to: '/showerdevicemanage' },
						{ label: this.$t('nav.shower.staff'), icon: 'pi pi-fw pi-pencil', to: '/showerstaffmanage' }
					]
				},
				{
					label: this.$t('nav.admin.group'),
					items: [
						{ label: this.$t('nav.admin.safety'), icon: 'pi pi-fw pi-sun', to: '/safermanage' },
						{ label: this.$t('nav.admin.logs'), icon: 'pi pi-fw pi-book', to: '/logs' }
					]
				},
				{
					label: this.$t('nav.help.group'),
					items: [
						{ label: this.$t('nav.help.docs'), icon: 'pi pi-fw pi-question', to: '/document' }
					]
				}
			];
		},
		getUserInfo() {
			const rawUserInfo = window.localStorage.getItem('userinfo');

			if (!rawUserInfo) {
				return null;
			}

			try {
				return JSON.parse(rawUserInfo);
			} catch (error) {
				return null;
			}
		},

        getTodayTotalEvent() {
            var today = new Date();
            this.$http('/api/admin/event/types', {
                enterprise_id: this.enterpriseId,
                time: today.getTime() - 86399999,
                times: today.getTime(),
            }).then(res => {
                if (res.code == 200) {
					this.eventRecordBadge = '' + (res.data.levels.checked + res.data.levels.unchecked);
                    this.$emit('todayTotalEvent', this.eventRecordBadge);
                }
            })
        },

        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        },
        // updateEventMenuHandler(e) {
        //     //window.localStorage.setItem('newEventCount', e)
        //     //this.menu[2].items[0].badge = e;
        // }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
		},
		menu() {
			const menu = this.buildMenu();
			const usr_info = this.getUserInfo();

			if (usr_info && usr_info.admin == 0) {
				menu[4] = menu[5];
				menu.pop();
			}

			return menu;
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
